import { FormattedMessage } from 'react-intl'
import { ModalWrapper, ModalHeader, ModalContent, ModalRow } from './styles'
import Modal from 'components/shared/Modal'
import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { darkMode } from 'styles/theme'

interface DifferentHoursProps {
    isOpened: boolean
    close: () => void
}

const SummerSalePromotionModal = ({ isOpened, close }: DifferentHoursProps) => (
    <Modal
        isOpened={isOpened}
        onClose={close}
        maxWidth={560}
        isBlur
        isMobileCentered
    >
        <ModalWrapper isFullWidth theme={darkMode}>
            <ModalHeader
                pt={[16, 32]}
                pr={[16, 40]}
                pb={[16, 32]}
                pl={[16, 40]}
                theme={darkMode}
            >
                <Text
                    variant="heading3"
                    color="grayscale_200"
                    style={{ width: '90%' }}
                >
                    <FormattedMessage
                        id="promo.summer_sale.discounts_header"
                        defaultMessage="Wysokość zniżek na bilety do parku w Letniej Wyprzedaży"
                    />
                </Text>
            </ModalHeader>
            <ModalContent isFullWidth>
                <Box mt={24} isFullWidth>
                    <Text variant="body16" color="primary_500" mb={[16, 24]}>
                        <FormattedMessage
                            id="promo.summer_sale.discounts_description"
                            defaultMessage="Zniżki obowiązują tylko na wejścia do parku w 2024 r."
                        />
                    </Text>
                    <ModalRow
                        direction="row"
                        justify="space-between"
                        isFullWidth
                        isFirst
                    >
                        <Text variant="bodySmall" color="grayscale_0">
                            <FormattedMessage
                                id="promo.summer_sale.discounts_01"
                                defaultMessage="Czerwiec - Sierpień"
                            />
                        </Text>
                        <Text variant="bodySmall" color="grayscale_0">
                            -15%
                        </Text>
                    </ModalRow>
                    <ModalRow
                        direction="row"
                        justify="space-between"
                        isFullWidth
                    >
                        <Text variant="bodySmall" color="grayscale_0">
                            <FormattedMessage
                                id="promo.summer_sale.discounts_02"
                                defaultMessage="Wrzesień - Listopad"
                            />
                        </Text>
                        <Text variant="bodySmall" color="grayscale_0">
                            -50%
                        </Text>
                    </ModalRow>
                    <ModalRow
                        direction="row"
                        justify="space-between"
                        isFullWidth
                        isLast
                    >
                        <Text variant="bodySmall" color="grayscale_0">
                            <FormattedMessage
                                id="promo.summer_sale.discounts_03"
                                defaultMessage="Grudzień"
                            />
                        </Text>
                        <Text variant="bodySmall" color="grayscale_0">
                            -30%
                        </Text>
                    </ModalRow>
                </Box>
            </ModalContent>
        </ModalWrapper>
    </Modal>
)

export default SummerSalePromotionModal
